import { useState } from 'react';
import ReactGA from 'react-ga4';
import { motion } from 'motion/react';

export const COOKIES_CONSENT_KEY = 'CookieConsent';

export type ConsentCode = 'granted' | 'denied';

export const CookiesConsent = () => {
  const [hidden, setHidden] = useState(!!localStorage.getItem(COOKIES_CONSENT_KEY));

  if (hidden) return null;

  const handleConsent = (consentCode: ConsentCode) => {
    ReactGA.gtag('consent', 'update', { analytics_storage: consentCode });
    localStorage.setItem(COOKIES_CONSENT_KEY, consentCode);
    setHidden(true);
  };

  const handleAccept = () => handleConsent('granted');
  const handleDeny = () => handleConsent('denied');

  return (
    <motion.div
      initial={{ translateY: '100%', opacity: 0 }}
      animate={{ translateY: '0', opacity: 1 }}
      transition={{ duration: 2, ease: 'easeInOut', delay: 10 }}
      className="z-48 md:w-min fixed inset-x-2 bottom-2 md:bottom-4 md:mx-auto bg-grey border-dashed border-white border p-6 text-white shadow-2xl shadow-black"
    >
      <div className="flex flex-col items-center gap-4">
        <span className="text-center text-sm font-medium md:w-max">
          Ce site utilise des cookies pour mesurer son audience. <br className="hidden md:block" /> Vous pouvez les accepter ou les refuser.
        </span>

        <div className="flex gap-8 text-sm">
          <button onClick={handleAccept} className="button hover:text-light-green p-2">
            Accepter
          </button>

          <button onClick={handleDeny} className="button hover:text-red p-2">
            Refuser
          </button>
        </div>
      </div>
    </motion.div>
  );
};
